(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/products-grid-widget/assets/javascripts/prepare-item-models.js') >= 0) return;  svs.modules.push('/components/sport/products-grid-widget/assets/javascripts/prepare-item-models.js'); "use strict";


(function () {
  'use strict';

  const GRID_ITEM_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
  };
  const MAP_ITEM_INDEX_TO_SIZE = [GRID_ITEM_SIZES.LARGE, GRID_ITEM_SIZES.MEDIUM, GRID_ITEM_SIZES.SMALL, GRID_ITEM_SIZES.SMALL, GRID_ITEM_SIZES.SMALL, GRID_ITEM_SIZES.SMALL];
  const mockableImports = {
    prepareProductItem: svs.isServer ? 
    require('./prepare-product-item.es6').prepareProductItem : svs.sport.productsGridWidget.prepareProductItem,
    prepareTipsenItem: svs.isServer ? 
    require('./prepare-tipsen-item.es6').prepareTipsenItem : svs.sport.productsGridWidget.prepareTipsenItem
  };

  async function prepareItemModels(_ref) {
    let {
      config,
      isMobile,
      trackingPrefix,
      req
    } = _ref;
    const {
      widgetId,
      tipsen,
      otherProducts
    } = config;
    const productItems = await Promise.all([mockableImports.prepareTipsenItem({
      itemConfig: tipsen,
      isMobile,
      size: MAP_ITEM_INDEX_TO_SIZE[0],
      trackingPrefix: "".concat(trackingPrefix, "/0"),
      widgetId,
      req
    }), ...otherProducts.map((itemConfig, pos) => mockableImports.prepareProductItem({
      itemConfig,
      isMobile,
      size: MAP_ITEM_INDEX_TO_SIZE[pos + 1],
      trackingPrefix: "".concat(trackingPrefix, "/").concat(pos + 1),
      widgetId,
      req
    }))]);
    return productItems;
  }

  if (svs.isServer) {
    module.exports = {
      prepareItemModels
    };
  } else {
    setGlobal('svs.sport.productsGridWidget.prepareItemModels', prepareItemModels);
    setGlobal('svs.sport.productsGridWidget.testInternals.prepareItemModels.getMockableImports', () => mockableImports);
  }
})();
 })(window);